import images from "./images"

const data = {
    user: {
        name: 'EVARA ADMIN',
        img: images.avt
    },
    
    
    overall: [
        {
            value: '300K',
            title: 'Orders'
        },
        {
            value: '9.876K',
            title: 'Customers'
        },
        {
            value: '1.234K',
            title: 'Products'
        },
        {
            value: '$5678',
            title: 'Revenue'
        }
    ],
   
}

export default data